const VideoPauseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={72}
    viewBox="0 0 72 72"
    fill="none"
    {...props}
  >
    <circle cx={36} cy={36} r={36} fill="white" fillOpacity={0.3} />
    <rect x={26} y={22} width={8} height={28} rx={2} fill="#E0E0E0" />
    <rect x={38} y={22} width={8} height={28} rx={2} fill="#E0E0E0" />
  </svg>
);
export default VideoPauseIcon;
